module.exports = __webpack_public_path__ + "img/006.dd5c274e.jpg";